

import React from 'react';
import './testimonials.css';
import Slider from 'react-slick';
import { Container, Row, Col } from 'reactstrap';

const testimonialData = [
    {
        name: 'Jack Pai',
        title: 'Web Developer',
        desc: "I just wanted to take a moment to express my gratitude and admiration for your incredible work. Your dedication, attention to detail, and passion for what you do are truly inspiring. You have a remarkable ability to consistently produce high-quality work and exceed expectations. Your contributions have been invaluable to our team and organization. Thank you for all that you do, and for making a positive impact on those around you."
    },
    {
        name: 'Chen Gen',
        title: 'Data Analysis',
        desc: "Your work is simply outstanding. Your creativity and expertise have brought new ideas and perspectives to the table, and your attention to detail and willingness to go the extra mile is truly impressive. I want to express my heartfelt appreciation for the excellent job you have done and the significant impact it has made. Your work is a true testament to your skills and dedication."
    },
    {
        name: 'Patrick Ombu',
        title: 'Software Engeneer',
        desc: "I just wanted to take a moment to recognize the incredible effort you have put into your work. You have consistently demonstrated a high level of commitment, enthusiasm, and professionalism that has not gone unnoticed. Your work has not only been exceptional, but it has also been instrumental in achieving our team's goals. Thank you for your hard work and for setting such a positive example for all of us."
    },
    {
        name: 'Justin Paulo',
        title: 'Fontend Developer',
        desc: "I wanted to take this opportunity to express my sincere gratitude for your excellent work. Your dedication, hard work, and positive attitude have made a significant impact on the success of our project. Your expertise and attention to detail have not gone unnoticed, and your work has been nothing short of exceptional. Thank you for your contributions and for being an integral part of our team."
    },
    {
        name: 'Bernard Gustz',
        title: 'Backend Developer',
        desc: "Your work is a true reflection of your outstanding abilities and exceptional work ethic. You consistently deliver high-quality results that have exceeded expectations, and your contributions have been a driving force behind the success of our project. I want to take this opportunity to express my deep appreciation for all that you do, and for being such a valuable member of our team. Your hard work, dedication, and talent have not gone unnoticed, and we are fortunate to have you on board."
    },
]

const Testimonials = () => {

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 3000,
        swipeToSlide: true,
    }
  return (
    <section>
        <Container>
            <Row>
                <Col lg='12' className='mb-5 text-center'>
                    <h2>What Pipo says about me</h2>
                </Col>

                <Col lg='6' className='m-auto'>
                    <Slider {...settings}>
                        {
                            testimonialData.map((item,index) =>(
                                <TestimonialItem
                                    key={index}
                                    name={item.name}
                                    title={item.title}
                                    desc={item.desc}
                                />
                            ))
                        }
                        
                    </Slider>
                </Col>
            </Row>
        </Container>
    </section>
  );
  }

  const TestimonialItem = ({ name, title, desc }) => {
    return <div>
            <div className="single-testimonial">
                <p>
                    {desc}
                </p>
                    <h6>{name}</h6>
                <p className='title'>{title}</p>
            </div>
        </div>
  }
export default Testimonials;